import { getMemberId, getUserId, getSvocId } from '../utils/customer';
import { getConfigurationValue, getHost } from '../utils/general';
const baseurl = getHost();
const memberId = getMemberId();
const userId = getUserId();
const svocId = getSvocId();
const rsaPublicKeyVer = getConfigurationValue('RSA_PUBLIC_KEY_VERSION');
export const B2C_ACCOUNT_PATH = '/customer/account/v1';
export const B2C_ONE_ACCOUNT_PATH = '/b2b/user/account/b2c';
export const B2B_ACCOUNT_PATH = '/b2b/user/account';
export const B2B_ACCOUNT_VIEW_PATH = '/b2b/account/view';
export const IMAGES_ASSETS_URL = 'https://assets.thdstatic.com/images/v1';
const showNewPurchaseHistoryPage = getConfigurationValue('ENABLE_NEW_PURCHASE_HISTORY_PAGE') === '1';
// B2C paths:
export const B2C_ACCOUNT_PATH_WITH_MEMBER_ID = `${B2C_ONE_ACCOUNT_PATH}/${memberId}`;
export const B2C_ACCOUNT_PAYMENT_PATH_WITH_MEMEBER_ID = `${B2C_ONE_ACCOUNT_PATH}/${memberId}`;
export const B2C_ADDRESSES_PATH = `${B2C_ACCOUNT_PATH_WITH_MEMBER_ID}/addresses`;
export const B2C_PAYMENTS_PATH = `${B2C_ACCOUNT_PAYMENT_PATH_WITH_MEMEBER_ID}/paymentcards`;
const B2C_PAYPAL_BASE_PATH = `${B2C_ACCOUNT_PAYMENT_PATH_WITH_MEMEBER_ID}/paypal`;
const B2C_PAYPAL_V2_BASE_PATH = `${B2C_ACCOUNT_PAYMENT_PATH_WITH_MEMEBER_ID}/v2/paypal`;
export const B2C_PAYPAL_INIT_PATH = `${B2C_PAYPAL_BASE_PATH}/initpaypal`;
export const B2C_PAYPAL_SAVE_PATH = `${B2C_PAYPAL_BASE_PATH}/verifysavepaypal`;
export const B2C_PAYPAL_V2_INIT_PATH = `${B2C_PAYPAL_V2_BASE_PATH}/initpaypal`;
export const B2C_PAYPAL_V2_SAVE_PATH = `${B2C_PAYPAL_V2_BASE_PATH}/verifysavepaypal`;
export const B2C_ACCOUNT_PROFILE_PATH = `${B2C_ACCOUNT_PATH_WITH_MEMBER_ID}/profile?checkPhoneEligibility=true`;
// B2B paths:
export const B2B_ACCOUNT_PATH_WITH_USER_ID = `${B2B_ACCOUNT_PATH}/${userId}`;
export const B2B_ACCOUNT_PATH_WITH_USER_ID_SVOC_ID = `${B2B_ACCOUNT_PATH_WITH_USER_ID}/customer/${svocId}`;
export const B2B_ADDRESSES_PATH = `${B2B_ACCOUNT_PATH_WITH_USER_ID_SVOC_ID}/addresses`;
export const B2B_UPDATE_ADDRESSES_PATH = `${B2B_ACCOUNT_PATH_WITH_USER_ID}/addresses`;
export const B2B_PAYMENTS_PATH = `${B2B_ACCOUNT_PATH_WITH_USER_ID_SVOC_ID}/payment`;
export const B2B_PAYMENTS_PATH_WITH_USER_ID = `${B2B_ACCOUNT_PATH_WITH_USER_ID}/payment`;
export const B2B_PAYMENTS_RETRIEVE_PATH = `${B2B_PAYMENTS_PATH}/retrieve`;
export const B2B_PRO_HOUSE_ACCOUNT_RETRIEVE_PATH = `${B2B_PAYMENTS_PATH}/houseAccount/retrieve`;
export const B2B_PRO_HOUSE_ACCOUNT_WITH_USER_ID_SVOC_ID_PATH = `${B2B_ACCOUNT_PATH_WITH_USER_ID_SVOC_ID}/payment/houseAccount`;
// Mock PHA account Enrollment/Unenrollment
export const B2B_PRO_HOUSE_ACCOUNT_T2C_ENROLL_PATH = `${B2B_PAYMENTS_PATH_WITH_USER_ID}/houseAccount/t2c`;
export const B2B_PRO_HOUSE_ACCOUNT_T2C_UNENROLL_PATH = `${B2B_PAYMENTS_PATH_WITH_USER_ID}/houseAccount/removet2c`;
export const B2B_UPDATE_PAYMENT_PATH = `${B2B_PAYMENTS_PATH_WITH_USER_ID}/update`;
export const B2B_UPDATE_STATUS_PATH = `${B2B_PAYMENTS_PATH_WITH_USER_ID}/updatestatus`;
export const B2B_ADD_UPDATE_NICKNAME_PATH = `${B2B_PAYMENTS_PATH_WITH_USER_ID}/addOrUpdateCardNickName`;
export const B2B_BILLING_ADDRESS_PATH = `${B2B_ACCOUNT_PATH_WITH_USER_ID_SVOC_ID}/billingAddress`;
export const B2B_PAYPAL_SET_CHECKOUT_PATH = `${B2B_ACCOUNT_PATH_WITH_USER_ID}/paypal/setExpressCheckout`;
export const B2B_PAYPAL_SAVE_PATH = `${B2B_ACCOUNT_PATH_WITH_USER_ID}/paypal/savePayPalAccount`;
export const B2B_PAYPAL_V2_SET_CHECKOUT_PATH = `${B2B_ACCOUNT_PATH_WITH_USER_ID}/v2/paypal/initPayPal`;
export const B2B_PAYPAL_V2_SAVE_PATH = `${B2B_ACCOUNT_PATH_WITH_USER_ID}/v2/paypal/savePayPalAccount`;
export const B2B_STOP_ALL_AUTHORIZATION = `${B2B_ACCOUNT_PATH_WITH_USER_ID_SVOC_ID}/payment/creditcard/stopPaa`;
export const B2B_ACCOUNT_PROFILE_PATH = `${B2B_ACCOUNT_PATH_WITH_USER_ID_SVOC_ID}/profile`;
export const B2B_ACCOUNT_CNP_ENROLLMENT = `${B2B_ACCOUNT_PATH_WITH_USER_ID_SVOC_ID}/payment/creditcard/CNPEnrollmentRequest`;
export const B2B_ACCOUNT_HD_WALLET_UNENROLLMENT = `${B2B_PAYMENTS_PATH}/hdWallet/unenroll`;
export const B2B_GET_CITI_CARDS = (citiAccountId) => `${B2B_ACCOUNT_PATH_WITH_USER_ID_SVOC_ID}/citi/${citiAccountId}/payment/retrieve`;
export const B2B_GIFT_CARD_BALANCE_PATH = `${B2B_PAYMENTS_PATH}/getGiftCardBalance`;
export const B2B_ACCOUNT_RESEND_T2C_PATH = `${B2B_ACCOUNT_PATH_WITH_USER_ID}/payment/creditcard/resendt2c`;
// Resend t2c invites for both PHA and CC. Resending invites for both single and multiple contacts
export const B2B_ACCOUNT_MULTI_RESEND_T2C_PATH = `${B2B_ACCOUNT_PATH_WITH_USER_ID}/payment/t2c/multiResend`;
export const B2B_PAYMENTS_PATH_WITH_USER_ID_SVOC_ID = `${B2B_ACCOUNT_PATH_WITH_USER_ID_SVOC_ID}/payment`;
export const B2B_PAYMENTS_PATH_WITH_USER_ID_V2 = `${B2B_ACCOUNT_PATH_WITH_USER_ID}/v2/payment`;
// B2B pages:
// Uses fs flag to render purchase history experience if active
export const B2B_PURCHASE_HISTORY_PAGE = showNewPurchaseHistoryPage
    ? `/myaccount/purchase-history`
    : `${B2B_ACCOUNT_VIEW_PATH}/order/summary`;
// Fetches a list of users like the Add Manage Users UI page on a B2B account
export const B2B_MANAGE_USERS_PATH = `${B2B_ACCOUNT_PATH_WITH_USER_ID_SVOC_ID}/manageuser`;
// Common paths:
export const ZIP_CODE_PATH = `${B2B_ACCOUNT_PATH}/zipCode`;
export const OG_UPDATE_ADDRESS_QA_URL = 'https://staging.v2.ordergroove.com/customer/update_shipping_default';
export const OG_UPDATE_ADDRESS_PROD_URL = 'https://api.ordergroove.com/customer/update_shipping_default';
export const PROFILE_PAGE_PATH = '/myaccount/profile';
export const B2B_ACCOUNT_HD_WALLET_ENROLLMENT = `${B2B_PAYMENTS_PATH_WITH_USER_ID_SVOC_ID}/hdWallet/enroll`;
// Link for Home Depot Credit Cards page
export const CREDIT_CARDS_PAGE_URL = '/myaccount/thdcreditcard';
// Links for Home Depot Gift Cards page
export const CASHSTART_RELOAD_GIFT_CARD_PAGE_URL = 'https://homedepot.cashstar.com/reload/?ref=THD1';
export const B2B_PURCHASE_GIFT_CARD_PATH = 'https://www.homedepot.com/c/Gift_Cards';
export const RELOAD_GIFT_CARD_PAGE_URL = '/gift-cards/balance';
// PayPal cancel and redirect links for B2C
export const PAYPAL_CANCEL_REDIRECT_PATH = `${baseurl}/myaccount/payments`;
export const PAYPAL_RETURN_PATH = `${baseurl}/myaccount/payments`;
export const PRO_XTRA_PERKS_PATH = `${baseurl}/b2b/account/view/proXtraPerks`;
// Pro Allowance Page
export const MANAGE_PRO_ALLOWANCE_PATH = '/myaccount/proallowance';
// OrangePay
export const GET_ORANGE_PAY_TOKEN = `/b2b/user/account/${svocId}/orangepay/${userId}/token`;
export const ORANGE_PAY_URL_STG = 'https://orangepay-ecommerce.payments-stg.homedepot.com/';
export const ORANGE_PAY_URL_PROD = 'https://orangepay-ecommerce.hdpayments.homedepot.com/';
export const ADD_CREDIT_CARD = `${B2B_ACCOUNT_PATH_WITH_USER_ID_SVOC_ID}/v2/payment/addPaymentCard`;
// How to authorize payments for Text2Confirm page
export const AUTHORIZE_CARDS_T2C_PAGE_URL = '/c/authorize-cards-text2confirm';
// RSA Encryption
export const GET_RSA_PUBLIC_KEY_URL = `https://assets.thdstatic.com/account/address-payments/rsa/${rsaPublicKeyVer}/public_key.txt`;
export const GET_RSA_PUBLIC_KEY_QA_URL = `https://assets.thdstatic.com/account/address-payments/rsa-qa/${rsaPublicKeyVer}/public_key.txt`;
export const B2B_ADD_CHECKING_ACCOUNT_ENCRYPTED = `${B2B_ACCOUNT_PATH_WITH_USER_ID_SVOC_ID}/v2/payment/addCheckingAccount`;
